import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { ChainID } from '@lukso/controllerapps-sharedlogic-primitives'

import { ProfileName } from './ProfileName'
import { ControllerAddress } from './ControllerAddress'
import { CustomControllerName } from './CustomControllerName'
import { ProfileAddress } from '../ProfileAddress'

const ProfilePropsSchema = z.object({
  name: z.instanceof(ProfileName).optional(),
  address: z.instanceof(ProfileAddress),
  deviceControllerAddress: z.instanceof(ControllerAddress),
  chainID: z.instanceof(ChainID),
  customControllerNames: z.array(z.instanceof(CustomControllerName)),
})

type ProfileProps = z.infer<typeof ProfilePropsSchema>

export class Profile extends ValueObject<ProfileProps> {
  public getName(): ProfileName | undefined {
    return this.props.name
  }

  public getAddress(): ProfileAddress {
    return this.props.address
  }

  public getControllerAddress(): ControllerAddress {
    return this.props.deviceControllerAddress
  }

  public getChainID(): ChainID {
    return this.props.chainID
  }

  public getCustomControllerNames(): CustomControllerName[] {
    return this.props.customControllerNames
  }

  public static create(props: ProfileProps): Profile {
    const validatedProps = ProfilePropsSchema.parse(props)
    return new Profile(validatedProps)
  }
}
